"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFieldNames = void 0;
var AddressFieldNames;
(function (AddressFieldNames) {
    AddressFieldNames["ADDITIONAL_INFO"] = "additionalInfo";
    AddressFieldNames["ADDRESS_SUGGESTIONS"] = "addressSuggestions";
    AddressFieldNames["CITY"] = "city";
    AddressFieldNames["COUNTRY"] = "country";
    AddressFieldNames["POSTAL_CODE"] = "postalCode";
    AddressFieldNames["PROVINCE"] = "province";
    AddressFieldNames["ROAD_NAME"] = "roadName";
    AddressFieldNames["ROAD_NUMBER"] = "roadNumber";
    AddressFieldNames["ROAD_TYPE"] = "roadType";
})(AddressFieldNames = exports.AddressFieldNames || (exports.AddressFieldNames = {}));
//# sourceMappingURL=types.js.map